import axios from 'axios';
import clientConfig from '../config';

let currentContext;

const getDevPortalContext = () => {
	if (!currentContext) {
		const envVar = sessionStorage.getItem('ENV') || import.meta.env.VITE_ENVIRONMENT || 'DEV';
		currentContext = axios.create({
			withCredentials: false,
			baseURL: clientConfig.externalUrl[envVar]
		});
	}

	return currentContext;
}

export default getDevPortalContext;